<template>
    <form class="edit-url" 
        @submit.prevent="applyNewUrl"
    >
        <div class="edit-url__title">Edit URL</div>
        <label class="edit-url__input-holder">
            Mapped URL
            <input type="text" 
                class="edit-url__input" 
                :class="{'edit-url__input_invalid': !!validationError}"
                ref="input1" 
                v-model="urlToEdit" 
            />
            <span v-if="validationError" 
                class="edit-url__validation-error"
            >
                {{ validationError }}
            </span>
        </label>
        <label class="edit-url__input-holder">
            Published URL
            <input type="text" 
                class="edit-url__input" 
                ref="input2" 
                v-model="publishedUrlToEdit" 
            />
        </label>
        <div class="edit-url__controls">
            <button type="submit" 
                class="edit-url__button edit-url__button_submit"
                :disabled="isSubmitButtonDisabled"
                >
                Apply
            </button>
            <button class="edit-url__button cancel-button" @click.stop.prevent="close()">
                Cancel
            </button>
        </div>
    </form>
</template>

<script>
const EMPTY_FIELD_VALIDATION_ERROR = 'This field can\'t be empty'
export default {
    name: 'EditUrlModal',
    data() {
        return {
            urlToEdit: this.url || '',
            publishedUrlToEdit: this.publishedUrl || ''
        }
    },
    props: {
        url: String,
        publishedUrl: String
    },
    mounted() {
        if (this.$refs['input1']) {
            this.$refs['input1'].focus()
        }
    },
    computed: {
        isSubmitButtonDisabled() {
            return !!this.validationError || (this.urlToEdit === this.url && this.publishedUrlToEdit === this.publishedUrl)
        },
        trimmedUrl() {
            return this.urlToEdit.trim()
        },
        validationError() {
            if (this.trimmedUrl === '') {
                return EMPTY_FIELD_VALIDATION_ERROR
            }
            
            return null
        }
    },
    watch: {
        url() {
            this.urlToEdit = this.url
        },
        publishedUrl() {
            this.publishedUrlToEdit = this.publishedUrl
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        applyNewUrl() {
            this.$emit('apply', this.trimmedUrl, this.publishedUrlToEdit.trim())
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
.edit-url {
    padding: 40px;

    &__title {
        text-align: center;
        font-size: 34px;
        font-weight: bold;
        margin-bottom: 35px;
        color: $rfx-dark-march;
    }

    &__input-holder {
        display: block;
        position: relative;
        padding-bottom: 20px;
        font-weight: bold;
    }

    &__input {
        height: 56px;
        padding: 0 15px;
        border: 1px solid $rfx-light-steel;
        outline: none;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        color: $rfx-dark-march;
        width: 100%;
        box-sizing: border-box;

        &_invalid {
            border-bottom-color: $rfx-red;
        }
    }

    &__validation-error {
        position: absolute;
        font-size: 12px;
        left: 10px;
        bottom: 0;
        color: $rfx-red;
    }

    &__controls {
        display: flex;
        flex-direction: row-reverse;
        margin-top: 20px;
    }

    &__button {
        height: 40px;
        padding: 0 20px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        border: none;
        outline: none;
        cursor: pointer;
        color: $rfx-dark-march;
        background-color: #fff;

        &_submit {
            background-color: $rfx-medium-march;
            color: #fff;
        }

        &:disabled {
            opacity: .4;
            cursor: default !important;
        }
    }
}
</style>